import React, { Component } from 'react';
import Badge from 'react-bootstrap/Badge'
import ModalImage from 'react-modal-image';
import AddCategoryModal from './addCategoryModal';
import http from '../services/httpService';
import _ from "lodash";

const imageApiEndpoint = process.env.REACT_APP_IMAGE_HOST;
const htmlApiEndpoint = process.env.REACT_APP_HTML_HOST;

const imageExtension = '.jpg'
const htmlExtension = '.html'

const apiEndpoint = 'emails';

class Email extends Component {
    state = {
        attributes: this.props.attributes,
        openCategoryModal: false
    };

    handleAddCategory = () => {
      console.log("Add Category!");
    }

    openAddCategoryModal = () => {
      this.setState({ openCategoryModal: true });
    }

    closeAddCategoryModal = () => {
      this.setState({ openCategoryModal: false });
    }

    updateAttributes = async () => {
      const { data: { emails: email } } = await http.get(apiEndpoint + '/' + this.state.attributes.id);
      this.setState({ attributes: email });
    }

    getEmailContainerAttributes = (shouldShowHeroImage) => {
      return "col-12 bg-paper " + (shouldShowHeroImage ? "col-lg-9" : "col-lg-6");
    }

    getEmailTextContainerAttributes = (shouldShowHeroImage) => {
      return "col-12 " + (shouldShowHeroImage ? "col-lg-8" : "col-lg-12");
    }

    render() {
        const { id, subject_line, sender, sent_at, preview_text,
                hero_image_path, categories } = this.state.attributes,
              { shouldShowHeroImage, shouldShowAdminView, parentCategories } = this.props,
              full_image_path = imageApiEndpoint + hero_image_path + imageExtension,
              full_html_path = htmlApiEndpoint + hero_image_path + htmlExtension,
              sent_at_as_datetime = new Date(sent_at);
        let sorted_categories = [...categories].sort(
                                  (a, b) => a.category.parent_category_name > b.category.parent_category_name ? 1 : -1
                                );
        return (
            <div className="row justify-content-center">
              <div className={ this.getEmailContainerAttributes(shouldShowHeroImage) }>
                <div className="row">
                  {shouldShowHeroImage &&
                      <div className="col-12 col-lg-4">
                        <div className="email-thumbnail-container">
                          <ModalImage
                              className="img-fluid p-3"
                              small={full_image_path}
                              medium={full_image_path} />
                        </div>
                      </div>
                  }
                  <div className={ this.getEmailTextContainerAttributes(shouldShowHeroImage) }>
                      <h4 className="mb-3 text-primary">
                        {shouldShowHeroImage
                          ? <a href={ full_html_path }
                             target="_blank"
                             rel="noopener noreferrer">{ subject_line }
                          </a>
                          : <div>{ subject_line }</div>
                        }
                      </h4>
                      <div className="preview_text"><p>{ preview_text }</p></div>
                      <div className="sender_text">
                      <p>
                          <b>{ sender.name }</b> &middot;
                             { " " }
                             { sent_at_as_datetime.toDateString() }
                             { " " }
                             &middot;
                             { sent_at_as_datetime.toLocaleTimeString() }</p>
                      </div>
                      <div className="row">
                        { sorted_categories.map(
                            ({ category }) => (
                              <div
                                className="col-auto py-1 category_custom"
                                key={ category.id }>
                                <Badge
                                  className="email-category-badge"
                                  variant="primary"
                                  key={ category.id }>
                                  { category.name }
                                </Badge>
                              </div>
                            )
                          )
                        }
                      </div>
                      {shouldShowAdminView &&
                        <React.Fragment>
                          <AddCategoryModal
                              emailId={ id }
                              show={ this.state.openCategoryModal }
                              handleSave={ this.updateAttributes }
                              handleClose={ this.closeAddCategoryModal }
                              parentCategories={ parentCategories }/>
                          <div className="row pl-3">
                            <button type="button" className="btn btn-rubyred" onClick={this.openAddCategoryModal}>
                              Add Category
                            </button>
                          </div>
                        </React.Fragment>
                      }
                  </div>
                </div>
              </div>
            </div>
        );
    }
}

export default Email;
